import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
/**
 * Link Button Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since v0.0.1
 */
let LinkButtonIndex = class LinkButtonIndex extends Vue {
    /**
     * Apply Styles Based on Props
     */
    styles() {
        return {
            'text-capitalize': this.capitalized,
            '--navigator': this.navigator,
            '-mobile': this.mobile,
            '--primary': this.primary,
            '-orange-theme': this.orangeTheme,
            '--edit': this.edit,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "capitalized", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "navigator", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "mobile", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "primary", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "edit", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "flat", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "exact", void 0);
__decorate([
    Prop({ required: false })
], LinkButtonIndex.prototype, "path", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], LinkButtonIndex.prototype, "orangeTheme", void 0);
LinkButtonIndex = __decorate([
    Component({
        name: 'LinkButton',
    })
], LinkButtonIndex);
export default LinkButtonIndex;
